import '@Global/download-publish-dialog';
import '@Global/modal';
import React from 'react';
import App from '@Components/app';
import {createRoot} from 'react-dom/client';
import ModalContainerDeprecated from '@Components/modal-container-deprecated/modal-container';
import {ModalContainer} from '@Components/modal-container';
import {LoadingToast} from '@Components/loading-toast';
import type {SharePanelProps} from '@Panels/share-panel/share-panel.types';
import {ShareItemType} from '@Panels/share-panel/share-panel.types';
import {openSharingModal} from '@Modals/share-modal/share-modal-library';

window.PMW.mergePMW(PMW, {
  openSharePosterModal: (props: SharePanelProps): void => {
    openSharingModal({...props, type: ShareItemType.POSTER});
  }
});

const a = document.createElement('div');
a.setAttribute('id', 'pmw-app');
document.body.appendChild(a);

const root = createRoot(document.getElementById('pmw-app')!);
root.render(
  <App>
    <ModalContainerDeprecated />
    <ModalContainer />
    <LoadingToast />
  </App>
);
